import axios from 'axios';
import config from '@/vue-caas/config/config.js';

const baseURI = config.setupApiUrl;
const userSimulatorStoreModule = {
  state: {
    userSimList: [],
    userDatarows: [],
    resultUserCompTest: null,
    userCompMoveData: [],
    resultUserCompValidate: null
  },
  actions: {
    getUserSimQueryList: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/userComponent/list`, params);
        commit('SET_STORE_USER_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_USER_LIST', []);
        throw err;
      }
    },
    testUserCompSimulator: async ({commit}, params) => {
      try {
        const response = await axios.post(`${baseURI}/userComponent/test`, params);
        commit('SET_STORE_RESULT_TEST', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        commit('SET_STORE_RESULT_TEST', null);
        throw err;
      }
    },
    getUserCompMoveData: async ({ commit }, params) => {
      try {
        const response = await axios.get(`${baseURI}/userComponent/detail/${params.userCompId}&${params.ver}`);
        commit('SET_STORE_USER_COMP_MOVE_DATA', response.data);
      } catch (err) {
        commit('SET_STORE_USER_COMP_MOVE_DATA', []);
        throw err;
      }
    },
    validateJS: async ({commit}, params) => {
      try {
        const response = await axios.post(`${baseURI}/userComponent/validate`, params);
        commit('SET_STORE_RESULT_VALIDATE', response.data);
      } catch (err) {
        // alert(err);
        commit('SET_STORE_RESULT_VALIDATE', null);
        throw err;
      }
    },
  },
  mutations: {
    'SET_STORE_USER_LIST' (state, userSimList) {
      state.userSimList = userSimList;
      state.userDatarows = userSimList;   
    },
    'SET_USER_FILTER'(state, params) {
      let locked = params.locked;
      let search = params.search;
      let arrFilter = state.userDatarows;
      if (locked != undefined && locked != '') {
        arrFilter = arrFilter.filter((item) => {
          return  item.lock_yn==locked;
        });
      }
      if (search != undefined && search != '') {
        arrFilter = arrFilter.filter((item) => {
          for (const prop in item) {
            if (prop == "lock_yn" || prop == "uc_name" || prop == "upd_dt" || prop == "uc_ver"){
                if (typeof item[prop] == 'string') {
                  let propValue = item[prop].toLowerCase();
                  let queryValue = search.toLowerCase();
                  if (propValue.includes(queryValue)) {
                    return true;
                  }
                } else if (typeof item[prop] == 'number') {
                  let propValue = item[prop].toString().toLowerCase();
                  let queryValue = search.toLowerCase();
                  if (propValue.includes(queryValue)) {
                    return true;
                  }
                }
            }
          }
        });
      }
      state.userSimList = arrFilter;
    },
    'SET_STORE_RESULT_TEST' (state, resultUserCompTest) {
      state.resultUserCompTest = resultUserCompTest;
    },
    'SET_STORE_USER_COMP_MOVE_DATA' (state, userCompMoveData) {
      state.userCompMoveData = userCompMoveData;
    },
    'SET_STORE_RESULT_VALIDATE' (state, resultUserCompValidate) {
      state.resultUserCompValidate = resultUserCompValidate;
    },
  },
  getters: {
    userSimList: state => state.userSimList,
    resultUserCompTest: state => state.resultUserCompTest,
    userCompMoveData: state => state.userCompMoveData,
    resultUserCompValidate: state => state.resultUserCompValidate,

  },

}
export default userSimulatorStoreModule;